import React, {Component} from 'react';
import logo from "./assets/sonol-logo.png";
import errorImage from "./assets/error-image.png";
import DalkanForm from "./DalkanForm";

class Dalkan extends Component {
    render() {
        return (
                <div className="gradient-container text-center">
                    <img className="logo-wrapper" src={logo} alt="סונול"/>
                    <div className="white-error-container mx-auto">
                        <div className="goods-gifts">
                            <img className="error-image" src={errorImage} alt=""/>
                            <h2 className="error-header">קבלת אישור תדלוק אוטומטי</h2>
                        </div>
                        <div className="error-form mx-auto">
                            <div className="error-form-header"> על מנת שנוכל לטפל בפנייתך <br /> מלא את הפרטים הבאים </div>
                            <DalkanForm/>
                        </div>
                    </div>
                </div>
        );
    }
}


export default Dalkan;



// WEBPACK FOOTER //
// ./src/Dalkan.js